import styled from 'styled-components';
import PropTypes from 'prop-types';

const InputTip = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
    color: ${props => props.theme.colors.bluemine};
    margin-bottom: ${props => props.marginBottom};
    margin-top: ${props => props.marginTop};
`;

InputTip.propTypes = {
    marginBottom: PropTypes.string
};

export default InputTip;



// WEBPACK FOOTER //
// ./src/components/atoms/form/InputTip.js